import { Component, OnInit, Input } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as pluginLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements OnInit {

  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    legend: {
      display: true,
      labels: { fontColor: "#fff" }
    },
    scales: {
      xAxes: [{
        gridLines: { display: false },
        ticks: {
          fontColor: "#fff",
          // maxRotation: 0, // if maxRotation is set to 0, this may cause of overlapping
          // minRotation: 0, // if minRotation is set to 0, this may cause of overlapping
          callback: (value, index, values) => { // using lamda expression to call "this"
            if (typeof value == 'number') {
              return (this.isSummary) ? this.nFormatter(value, 1) : value;
            }
            if (typeof value == 'string') {
              return (this.xLabelMaxLength > 0) 
                          ? (value.length > this.xLabelMaxLength ? (value.substring(0, this.xLabelMaxLength) + '...') : value)
                          : value;
            }
            return value;
          }
        },
        /*scaleLabel: { // not known yet, if uncommented, it will make the x axis not on bottom
          display: true,
          labelString: "",
          fontColor: "#fff",
        },*/
      }],
      yAxes: [{
        gridLines: { display: false},
        ticks: {
          fontColor: "#fff",
          // suggestedMin: 0,
          padding: 20,
          // display: false
          callback: (value, index, values) => { // using lamda expression to call "this"
            if (typeof value == 'number') {
              return (this.isSummary) ? this.nFormatter(value, 1) : value;
            }
            if (typeof value == 'string') {
              return (this.yLabelMaxLength > 0) 
                          ? (value.length > this.yLabelMaxLength ? (value.substring(0, this.yLabelMaxLength) + '...') : value)
                          : value;
            }
            return value;
          }
        }
      }],
    },
    layout: {
      padding: {
        right: 20
      }
    },
    plugins: {
      labels: false,
      datalabels: {
        color: "#fff",
        // backgroundColor: ((context: Context) => this.hexToRGB(context.dataset.borderColor, 0.3)),
        borderRadius: 4,
        // font: { weight: 'bold' },
        formatter: (value, context) => {
          return new Intl.NumberFormat("vi-VN").format(value);
        },
        padding: 6,
        display: function (context) {
          // No need to show the label if the value is smaller than 1 (ex: 0)
          if (typeof context.dataset.data[context.dataIndex] === "number") {
            const value = context.dataset.data[context.dataIndex] as number;
            return value < 1 ? false : 'auto';
          }
          return 'auto';
        },
        // display: false,
        clamp: true,
        font: {
          size: 11
        }
      }
    },
    tooltips: {
      callbacks: {
        title: (tooltipItems, data) => { return (data.labels[tooltipItems[0].index] + "").replace(/,/g, " "); },
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var currentValue = parseFloat(dataset.data[tooltipItem.index].toString());
          return new Intl.NumberFormat("vi-VN").format(currentValue);
        }
      }
    }
  };

  public lineChartType: ChartType = 'line';
  public lineChartPlugins = [pluginLabels, {
    beforeInit: function (chart, options) {
      chart.legend.afterFit = function () {
        this.height += 20; // must use `function` and not => because of `this`
      };
    }
  }];

  @Input()
  public lineChartData: ChartDataSets[] = [];

  @Input()
  public lineChartLabels: Label[] = [];

  @Input()
  public lineChartColors: Color[] = [];

  @Input()
  public lineChartLegend = true;

  @Input()
  public isSummary = false;

  @Input()
  public height: any;

  @Input()
  public xLabelMaxLength = 0;

  @Input()
  public yLabelMaxLength = 0;

  constructor() { }

  ngOnInit() {
  }

  public hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  }

  /**
   * Go to bar-chart.component.ts to see the example 
   * @param num 
   * @param digits 
   * @returns the sumarized number
   */
  private nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function(item) {
      return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  }

  public getHeight() {
    if (typeof this.height == "number") {
      return this.height > 0 ? (this.height + 'px') : 'auto';
    }
    return this.height;
  }
}
